import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Toaster } from '@/components/ui/sonner';
import { SplashScreen } from '@/components/SplashScreen';
import { InstallBanner } from '@/components/InstallBanner';
import { AnnouncementModal } from '@/components/AnnouncementModal';
import { ErrorFallback } from '@/components/shared/ErrorFallback';
import { AppRouter } from '@/apps/app/AppRouter';
import { CoachRouter } from '@/apps/coach/CoachRouter';
import { getAppContext } from '@/lib/app-context';
import { useAuthStore } from '@/store/useAuthStore';

export default function App() {
  const [showSplash, setShowSplash] = useState(true);
  const user = useAuthStore((s) => s.user);
  const context = getAppContext();
  const isAppSurface = context === 'app';

  return (
    <>
      {isAppSurface && showSplash && (
        <SplashScreen onDone={() => setShowSplash(false)} />
      )}
      <BrowserRouter>
        <Sentry.ErrorBoundary fallback={(props) => <ErrorFallback {...props} />}>
          {context === 'coach' ? <CoachRouter /> : <AppRouter />}
        </Sentry.ErrorBoundary>
        {isAppSurface && user && <AnnouncementModal userId={user.id} />}
        <Toaster position="top-center" richColors />
        {isAppSurface && <InstallBanner />}
      </BrowserRouter>
    </>
  );
}
